/* ============
 * State of cvc module
 * ============
 *
 * The initial state of the cvc module.
 */

export default {
  paymentsParams: null,
  subscribe: 0
}



// WEBPACK FOOTER //
// ./src/store/modules/payments/state.js